import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface ContactDetails {
  email: string;
  phone: string;
  whatsapp: string;
  address: string;
  address_ar: string | null;
  page_title: string;
  page_title_ar: string | null;
  page_subtitle: string;
  page_subtitle_ar: string | null;
}

const defaultContactDetails: ContactDetails = {
  email: "support@anayperfume.com",
  phone: "+971504996672",
  whatsapp: "+971504996672",
  address: "Dubai, UAE",
  address_ar: null,
  page_title: "Contact Us",
  page_title_ar: null,
  page_subtitle: "We'd love to hear from you.",
  page_subtitle_ar: null,
};

export const useContactDetails = () => {
  const [contactDetails, setContactDetails] = useState<ContactDetails>(defaultContactDetails);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContactDetails = async () => {
      try {
        const { data, error } = await supabase
          .from("contact_details")
          .select("*")
          .limit(1)
          .maybeSingle();

        if (error) throw error;
        if (data) {
          setContactDetails({
            email: data.email || defaultContactDetails.email,
            phone: data.phone || defaultContactDetails.phone,
            whatsapp: data.whatsapp || defaultContactDetails.whatsapp,
            address: data.address || defaultContactDetails.address,
            address_ar: data.address_ar || null,
            page_title: data.page_title || defaultContactDetails.page_title,
            page_title_ar: data.page_title_ar || null,
            page_subtitle: data.page_subtitle || defaultContactDetails.page_subtitle,
            page_subtitle_ar: data.page_subtitle_ar || null,
          });
        }
      } catch (error) {
        console.error("Failed to load contact details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchContactDetails();
  }, []);

  const formatWhatsAppLink = (number?: string) => {
    const num = number || contactDetails.whatsapp;
    const cleanNumber = num.replace(/[^\d+]/g, "").replace("+", "");
    // Use web.whatsapp.com on desktop (api.whatsapp.com is often blocked by
    // corporate networks / browser policies) and wa.me on mobile so the
    // native app opens directly.
    const isMobile =
      typeof navigator !== "undefined" &&
      /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
    return isMobile
      ? `https://wa.me/${cleanNumber}`
      : `https://web.whatsapp.com/send?phone=${cleanNumber}`;
  };

  return { contactDetails, loading, formatWhatsAppLink };
};
